export const SET_FORM_TEMPLATES = 'SET_FORM_TEMPLATES'
export const ADD_FORM_TEMPLATE = 'ADD_FORM_TEMPLATE'
export const DELETE_FORM_TEMPLATE = 'DELETE_FORM_TEMPLATE'
export const DELETE_MULTIPLE_FORM_TEMPLATES = 'DELETE_MULTIPLE_FORM_TEMPLATES'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const SET_SELECTED_FORM_TEMPLATES = 'SET_SELECTED_FORM_TEMPLATES'
export const SET_TOTAL_FORM_TEMPLATES = 'SET_TOTAL_FORM_TEMPLATES'
export const UPDATE_FORM_TEMPLATE = 'UPDATE_FORM_TEMPLATE'
export const SET_VIEW_USER_GUIDE = 'SET_VIEW_USER_GUIDE'
